export const type = 'form.dateTimeRangePicker';
